import { render, staticRenderFns } from "./Susalud.vue?vue&type=template&id=52027598&scoped=true"
import script from "./Susalud.vue?vue&type=script&lang=js"
export * from "./Susalud.vue?vue&type=script&lang=js"
import style0 from "./Susalud.vue?vue&type=style&index=0&id=52027598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52027598",
  null
  
)

export default component.exports